export default __webpack_public_path__ + "static/media/PYTHON_SDK.b9e09748.jpg";